import { action } from '@/lib/api';
import clone from '@/lib/clone';
import pushChangesQueueItem from '@/redux/actions/pushChangesQueueItem';
import waitForSyncReady from '@/redux/actions/waitForSyncReady';
import { store } from '@/redux/lib/configureStore';
import cookUpdatedWorkflowStep from '@/screens/workflows/lib/cookUpdatedWorkflowStep';
import { getDeep } from '@shared/utils/getDeep.js';
import { setDeep } from '@shared/utils/setDeep.js';
import fetchWorkflowStepLongPollResponses from '../../workflowEditor/workflowEditorPanels/primaryPanels/webhookPanel/triggerStatusPane/utils/fetchWorkflowStepLongPollResponses';
import workflowScreenSelectors from '../selectors/workflowScreenSelectors';

const stepActions = {
  set(path, payload, opts = {}) {
    return new Promise(async (resolve) => {
      const state = store.getState();
      const stepId = opts?.stepId;
      const stepSelector = stepId ? workflowScreenSelectors.activeWorkflowStepById(state, stepId) : workflowScreenSelectors.activeWorkflowStep(state);
      const activeStep = clone(stepSelector);
      const newStep = setDeep(activeStep, path, payload);

      action('PUT_WORKFLOW_STEP', newStep);

      const cookedStep = await cookUpdatedWorkflowStep(state, newStep, { skipMessageEvaluation: true, skipValidation: true });
      if (!cookedStep.success) {
        console.error('Failed cooking step', cookedStep);
        return;
      }

      if (payload === null) {
        cookedStep.data = setDeep(cookedStep?.data, path, null);
      }

      const value = getDeep(path, cookedStep?.data);
      action('PUT_WORKFLOW_STEP', cookedStep?.data);
      pushChangesQueueItem('workflowStep', { workflowId: activeStep?.workflowId, stepId: newStep?.id, path, value });
      resolve();

      if (activeStep?.options?.triggerPoll && path.startsWith('arguments')) {
        action('SET_LONG_POLL_RESPONSE', { stepId: newStep?.id, data: {} });
        await waitForSyncReady();
        fetchWorkflowStepLongPollResponses({ workflowId: activeStep?.workflowId, stepId: newStep?.id });
      }
    });
  },

  setSchedule(args, opts = {}) {
    return new Promise((resolve) => {
      const state = store.getState();
      const workflow = workflowScreenSelectors.activeWorkflow(state);
      const stepId = opts?.stepId;
      const step = stepId ? workflowScreenSelectors.activeWorkflowStepById(state, stepId) : workflowScreenSelectors.activeWorkflowStep(state);

      pushChangesQueueItem('workflowSchedule', { workflowId: workflow?.id, stepId: step?.id, value: args });
      resolve();
    });
  },

  setPartialSchedule(path, payload, stepId) {
    return new Promise((resolve) => {
      const state = store.getState();
      const workflow = workflowScreenSelectors.activeWorkflow(state);
      const step = stepId ? workflowScreenSelectors.activeWorkflowStepById(state, stepId) : workflowScreenSelectors.activeWorkflowStep(state);

      const newStep = setDeep(step, path, payload);
      const value = newStep?.arguments;

      pushChangesQueueItem('workflowSchedule', { workflowId: workflow?.id, stepId: step?.id, value });
      resolve();
    });
  }
};

export default stepActions;
